<template>
  <el-row>
    <el-card shadow="never" class="mt-0 card-promo">
      <el-radio-group
        v-model="Promo.promoTargetStrata.promoValue.promoValueType"
        style="width: 100%"
      >
        <template v-for="(formradio, idx) in formRadio">
          <el-row :key="idx">
            <el-col :span="10">
              <el-radio :label="formradio.value" class="mt-2">{{ formradio.label }}</el-radio>
            </el-col>
            <el-col :span="14">
              <el-form-item
                v-for="(form, idx) in formradio.form"
                :key="form.key"
                size="small"
                style="margin: 0; display: flex"
              >
                <el-row type="flex">
                  <el-row style="flex-wrap: wrap; width: 80%" type="flex" justify="space-between">
                    <template v-for="(subForm, indx) in  form.value">
                      <el-col :span="subForm.span" style="margin-bottom: 18px" :key="indx">
                        <el-input
                          v-if="subForm.type == 'text' || subForm.type == 'password' || subForm.type == 'number'"
                          v-model="Promo.promoTargetStrata.promoValue[formradio.value][idx][subForm.id]"
                          :placeholder="subForm.placeholder"
                          :type="subForm.type"
                        ></el-input>
                      </el-col>
                    </template>
                  </el-row>
                  <el-row style="width: 20%;">
                    <el-col :span="3" :key="idx">
                      <el-button
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        @click="() => formradio.remove(idx)"
                      ></el-button>
                    </el-col>
                  </el-row>
                </el-row>
              </el-form-item>
              <el-row type="flex" justify="center">
                <el-button type="success" round size="mini" @click="formradio.add" class="mb-2">Add Strata</el-button>
              </el-row>
            </el-col>
          </el-row>
        </template>
      </el-radio-group>
    </el-card>
  </el-row>
</template>

<script>
export default {
  props: ["Promo"],
  data() {
    return {
      activeName: "first",
      formRadio: [
        {
          label: "Strata",
          value: "strata",
          add: this.addDomain,
          remove: this.removeFormItem,
          form: [
            {
              key: 0,
              value: [
                {
                  type: "text",
                  id: "discountValue",
                  label: "",
                  placeholder: "Discount Value",
                  rules: [],
                  span: 22,
                },
                {
                  type: "text",
                  id: "limit",
                  label: "",
                  placeholder: "Limit",
                  rules: [],
                  span: 22,
                },
              ]
            }
          ]
        },
        {
          label: "Strata Price Cut",
          value: "strataPriceCut",
          add: this.addDomainTwo,
          remove: this.removeFormItemTwo,
          form: [
            {
              key: 0,
              value: [
                {
                  type: "text",
                  id: "priceCutValue",
                  label: "",
                  placeholder: "Price Cut Value",
                  rules: [],
                  span: 22,
                },
                {
                  type: "text",
                  id: "limit",
                  label: "",
                  placeholder: "Limit",
                  rules: [],
                  span: 22,
                },
              ]
            }
          ]
        }
      ]
    };
  },
  computed: {

  },
  methods: {
    removeFormItem(index) {
      if (index !== 0) {
        this.formRadio[0].form.splice(index, 1);
        this.Promo.promoTargetStrata.promoValue.strata.splice(index, 1);
      }
    },
    removeFormItemTwo(index) {
      if (index !== 0) {
        this.formRadio[1].form.splice(index, 1);
        this.Promo.promoTargetStrata.promoValue.strataPriceCut.splice(index, 1);
      }
    },
    addDomain() {
      const getIndex = this.formRadio[0].form.length
      this.Promo.promoTargetStrata.promoValue.strata.push({
        discountValue: '',
        limit: ''
      })
      this.formRadio[0].form.push(
        {
          key: getIndex,
          value: [
            {
              type: "text",
              id: "discountValue",
              label: "",
              placeholder: "Discount Value",
              rules: [],
              span: 22,
            },
            {
              type: "text",
              id: "limit",
              label: "",
              placeholder: "Limit",
              rules: [],
              span: 22,
            },
          ]
        }
      );
    },
    addDomainTwo() {
      const getIndex = this.formRadio[1].form.length
      this.Promo.promoTargetStrata.promoValue.strataPriceCut.push({
        priceCutValue: '',
        limit: ''
      })
      this.formRadio[1].form.push(
        {
          key: getIndex,
          value: [
            {
              type: "text",
              id: "priceCutValue",
              label: "",
              placeholder: "Price Cut Value",
              rules: [],
              span: 22,
            },
            {
              type: "text",
              id: "limit",
              label: "",
              placeholder: "Limit",
              rules: [],
              span: 22,
            },
          ]
        }
      );
    }
  },
  created() {
    const valueStrata = this.Promo.promoTargetStrata.promoValue.strata
    const valueStrataPrice = this.Promo.promoTargetStrata.promoValue.strataPriceCut
    if (valueStrata.length > 1) {
      for (let i = 1; i < valueStrata.length; i++) {
        this.formRadio[0].form.push(
          {
            key: i,
            value: [
              {
                type: "text",
                id: "discountValue",
                label: "",
                placeholder: "Discount Value",
                rules: [],
                span: 22,
              },
              {
                type: "text",
                id: "limit",
                label: "",
                placeholder: "Limit",
                rules: [],
                span: 22,
              },
            ]
          }
        );
      }
    }
    if (valueStrataPrice.length > 1) {
      for (let i = 1; i < valueStrataPrice.length; i++) {
        this.formRadio[1].form.push(
          {
            key: i,
            value: [
              {
                type: "text",
                id: "priceCutValue",
                label: "",
                placeholder: "Price Cut Value",
                rules: [],
                span: 22,
              },
              {
                type: "text",
                id: "limit",
                label: "",
                placeholder: "Limit",
                rules: [],
                span: 22,
              },
            ]
          }
        );
      }
    }
  }
};
</script>

<style>
.tab-promo /deep/ .el-tabs__item {
  padding: 0px 20px !important;
}
.tab-promo /deep/ .el-tabs__item.is-active {
  color: white !important;
  background-color: #2356c9;
  padding: 0px 20px !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-weight: bold;
}
.tab-promo /deep/ .el-tabs__header.is-top {
  margin: 0 !important;
}
.card-promo {
  background-color: #f6f6f6 !important;
}
</style>
